import { gql } from '@apollo/client'

export const cityResultFragment = gql`
  fragment cityResult on CityResult {
    id
    slug
    name
    geoInfo {
      latitude
      longitude
    }
    country {
      code
      name
    }
  }
`
